export enum GridEditMode {
    EDIT,
    SOLVE
}


// WEBPACK FOOTER //
// ./src/models/grid-edit-mode.ts